/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GlobalContext from "../../../components/Context/GlobalContext";
import ErrorMessage from "../../../components/ErrorMessage";
import { userService } from "../../../services/user.services";
import Button from "../../../components/Button";
import Header from "./Header";

export default function SetNewPassword() {
    const [newType, setNewtype] = useState("password");
    const [confirmType, setConfirmtype] = useState("password");
    const [urlPrams, setUrlParams] = useSearchParams();
    const [errormessage, seterrormessage] = useState('');
    const navigateLogin = useNavigate()
    const [submitSelected, setsubmitSelected] = useState(false);
    const [error, seterror] = useState({
        criteriaError: '',
        inputError: ''
    })

    const [loading, setloading] = useState(false)
    const { setToastmessage, setToastErrorMessage, Toastmessage } = useContext(GlobalContext);
    const [password, setpassword] = useState({
        newPassword: '',
        confirmPassword: ''
    })
    const { newPassword,
        confirmPassword } = password
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$])[a-zA-Z\d!@#$]{8,}$/;
    const handleInput = (key, value) => {
        setpassword((prv) => ({
            ...prv,
            [key]: value
        }))
    }


    const isError = (key) => submitSelected && !loading && (!passwordRegex.test(newPassword));
    const iscompareError = (key) => submitSelected && !loading && (newPassword !== confirmPassword) || (newPassword === '' && confirmPassword === '');
    const checkState = () => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,16}$/.test(newPassword) === false
    const navigate = useNavigate();
    useEffect(() => {
        const token = urlPrams.get('token');
        if (token === null || token === undefined) {
            navigate('/')
        }

    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setloading(true)
        setNewtype('password');
        setConfirmtype('password')
        setsubmitSelected(true);
        if (newPassword === '' && confirmPassword === '') {
            seterror((prv) => ({
                ...prv,
                'inputError': 'This field is mandatory'
            }));
            setloading(false);
            return
        }
        if (newPassword !== confirmPassword) {
            seterror((prv) => ({
                ...prv,
                'inputError': 'Password do not match'
            }));
            setloading(false);
            return

        }
        if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,16}$/.test(newPassword) === false) {
            setloading(false);
            return

        }
        const payload = {
            token: urlPrams.get('token'),
            "new_password": newPassword,
            "confirm_password": confirmPassword
        }

        try {
            const response = await userService.resetPassword('admin-users/forgot-password-reset', payload);

            if (!response.error) {
                setToastmessage(response.data.message)
                setloading(false);
                navigate('/')

            } else {
                seterror((prv) => ({
                    ...prv,
                    'inputError': response.message?.message || 'Something went wrong'
                }));
                setloading(false)
                return
            }
        } catch (error) {
            console.log(error)

        }

    }
    return (
        <div>
            <div className="w-[100vw] h-[100vh] bg-[#F5F5F5] flex flex-col">
                {/* <header className="pt-[23px] pb-[24px] px-[24px] bg-primary flex space-x-[9px] items-center">
                    <h1 className="text-white font-minionpro text-xl font font-medium">
                        Maison QR
                    </h1>
                    <img src="/assets/images/vertical.svg" alt="" />
                    <span className="font-minionpro text-base font-medium text-white">
                        Admin
                    </span>
                </header> */}
                <Header />

                <div className="w-[100wh] h-[100vh] flex justify-center items-center">
                    <div className="w-fit px-10 sm:px-[130px] text-center bg-white m-4 rounded-[8px]">
                        <h1 className="pt-[38px] text-[#666] font-minionpro text-2xl font-normal">
                            Set New Password
                        </h1>
                        {/* <p className="font-minionpro text-[#666] text-base font-normal pt-[16px]">
                            Password must be at least 8 characters long <br />
                            with at least 1 uppercase letter, 1 lowercase <br />
                            letter, 1 special character, and 1 number.
                        </p> */}
                        <div className="relative pt-[24px]">
                            <div className="flex justify-center">
                                <div className="relative w-full flex justify-center">
                                    <div className="relative w-[100%]">
                                        <input
                                            type={newType}
                                            // className={`${isError()?'input-error':'input-border'} peer m-0 block h-[58px] w-[100%] rounded-[4px] border border-solid border-[#ddd] bg-transparent bg-clip-padding px-3 pr-[47px] py-4 text-base font-minionpro font-normal outline-none text-black transition duration-200 ease-linear placeholder-[#1F1F1F] focus:border-[#ddd] focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-neutral-700 focus:outline-none peer-focus:text-black dark:border-[#ddd] dark:text-black dark:focus:border-black dark:peer-focus:text-black [&:not(:placeholder-shown)]:pb-[0.625rem] [&:not(:placeholder-shown)]:pt-[1.625rem]`}
                                            id="newPassword"
                                            className={`w-full ${isError() ? 'input-error' : 'input-border'}  font-semibold  pl-3 pr-[52px]  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            data-testid='new_password'
                                            onFocus={() => setsubmitSelected(false)}
                                            placeholder=""
                                            onChange={(e) => handleInput('newPassword', e.target.value)}
                                        />
                                        {/* <label
                                            // for="floatingInput"
                                            className={`pointer-events-none absolute left-0 top-0 origin-[0_0] border border-solid border-transparent px-3 py-4  ${isError()?'text-[#FC4523] ':'text-[#1F1F1F]'} font-minionpro transition-[opacity,_transform] duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.85] peer-focus:text-black peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.85] motion-reduce:transition-none dark:text-black dark:peer-focus:text-black`}
                                        > */}
                                        <label for="newPassword" class={`peer-focus:dark: ${isError() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block  peer-focus:font-normal ${newPassword?.length > 0 ? 'font-normal' : 'font-semibold'}  leading-tight text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}>New password</label>
                                        
                                        {/* </label> */}
                                    </div>
                                </div>

                            </div>



                            {newType === "text" ? (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src="/assets/images/eye-open.svg"
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setNewtype("password")}
                                />
                            ) : (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src={`/assets/images/${isError() ? 'eye-error.svg' : 'eye.svg'}`}
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setNewtype("text")}
                                />
                            )}
                        </div>
                        {newPassword.length > 0 &&
                            <div>
                                <p className="text-[#666666] text-[16px] text-left mt-3">Password must have atleast:</p>
                                <p className={`text-left font-minionpro ${newPassword.length > 7 ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>8+ characters</p>
                                <p className={`text-left font-minionpro ${/[A-Z]/.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>1 uppercase</p>
                                <p className={`text-left font-minionpro ${/[a-z]/g.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>1 lowercase</p>
                                <p className={`text-left font-minionpro ${/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>1 special character</p>
                                <p className={`text-left font-minionpro ${/\d/g.test(newPassword) ? 'text-[#6BB231]' : 'text-[#FC4523]'}`}>1 number</p>
                            </div>}

                        <div className="relative pt-[16px]">
                            <div className="flex justify-center">
                                <div className="relative w-full flex justify-center">
                                    <div className="relative w-[100%]">
                                        <input
                                            type={confirmType}
                                            // className={`${submitSelected && iscompareError() ? 'input-error' : 'input-border'} peer m-0 block h-[58px] w-[100%] rounded-[4px] border border-solid border-[#ddd] bg-transparent bg-clip-padding px-3 pr-[47px] py-4 text-base font-minionpro font-normal outline-none text-black transition duration-200 ease-linear placeholder-[#1F1F1F] focus:border-[#ddd] focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-neutral-700 focus:outline-none peer-focus:text-black dark:border-[#ddd] dark:text-black dark:focus:border-black dark:peer-focus:text-black [&:not(:placeholder-shown)]:pb-[0.625rem] [&:not(:placeholder-shown)]:pt-[1.625rem]`}
                                            id="confirmPassword"
                                            className={`w-full ${submitSelected && iscompareError() ? 'input-error' : 'input-border'}  font-semibold  pl-3 pr-[52px]  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            data-testid='confirm_password'
                                            onFocus={() => setsubmitSelected(false)}
                                            placeholder=""
                                            onChange={(e) => handleInput('confirmPassword', e.target.value)}

                                        />

                                        {/* <label
                                            // for="floatingInput"
                                            className={`pointer-events-none absolute left-0 top-0 origin-[0_0] border border-solid border-transparent px-3 py-4 ${submitSelected && iscompareError() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'}font-minionpro transition-[opacity,_transform] duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.85] peer-focus:text-black peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.85] motion-reduce:transition-none dark:text-black dark:peer-focus:text-black`}
                                        >
                                            Confirm Password
                                        </label> */}
                                        <label for="confirmPassword" class={`peer-focus:dark: ${submitSelected && iscompareError() ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block  peer-focus:font-normal ${confirmPassword?.length > 0 ? 'font-normal' : 'font-semibold'}  leading-tight text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}>Confirm password</label>
                                    </div>
                                </div>
                            </div>

                            {confirmType === "text" ? (
                                <img
                                    className="absolute top-[32px] right-[16px] cursor-pointer"
                                    src="/assets/images/eye-open.svg"
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setConfirmtype("password")}
                                />
                            ) : (
                                <img
                                    className="absolute top-[32px] right-[16px] cursor-pointer"
                                    src={`/assets/images/${submitSelected && iscompareError() ? 'eye-error.svg' : 'eye.svg'}`}
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setConfirmtype("text")}
                                />
                            )}
                            {submitSelected && !loading && error.inputError !== '' && <ErrorMessage error message={error.inputError} classKey={'font-normal text-left text-sm text-[#FC4523] mt-[12px]'} />}

                            <br />
                        </div>
                        <Button
                            text="Set Password"
                            type="submit"
                            testId="reset-btn"
                            disabled={loading}
                            handleClick={handleSubmit}
                            loading={loading}
                            classKey={`w-[100%] ${checkState() ? 'bg-[#9E2064]' : 'bg-[#9E2064]'} bg-primary px-4 py-[16px] mt-4 mb-[52px] text-white rounded-[0.75rem] font-minionpro font-bold text-lg`}

                        />
                        <div
                            className="flex space-x-[4px] justify-center items-center mt-[21px] mb-[18px] cursor-pointer"
                            onClick={() => navigateLogin("/login")}
                        >
                            <img
                                src="../../assets/images/arrow-left.png"
                                alt="left-arrow"
                            />
                            <p className="font-minionpro font-semibold text-xs">
                                Return to Sign in
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
